// Constantes de base de datos - Este archivo no debe importar nada para evitar ciclos
export const LEARNING_STORE_NAMES = {
    COURSES: 'learning_courses',
    CONTENTS: 'learning_contents',
    EVALUATIONS: 'learning_evaluations',
    CATEGORIES: 'learning_categories',
    LEARNING_VERSION: 'learnings',
    ANSWERS_EVALUATIONS: 'answers_learning_evaluations',
    SAVE_PROGRESS_TRAINING: 'save_progress_training',
    ANSWERS_SURVEY: 'answers_learning_surveys',
    COURSES_ZIP_VERSION: 'courses_zip_version',
}

export const PORTFOLIO_STORE_NAMES = {
    CATEGORIES: 'ecommerce_categories',
    BRANDS: 'ecommerce_brands',
    PRODUCTS: 'ecommerce_products',
}

export const BENEFITS_STORE_NAMES = {
    BENEFIT_VERSION: 'benefits',
    BENEFIT_VOUCHERS: 'benefit_vouchers',
    BENEFIT_HISTORY: 'benefit_history_points',
    REDEEMS: 'benefit_redeems',
    POINTS_AWARDED: 'benefit_awarded_points',
}

export const SCHEDULES_STORE_NAMES = {
    SCHEDULES_VERSION: 'schedules_version',
    PERFECT_STORE_VERSION: 'pf_version',
    CAMPAINGS: 'campaings',
    SCHEDULES: 'schedules',
    STORES: 'stores',
    FORMS: 'stores_forms',
    CHECKIN: 'transaction_checkins',
    CHECKOUT: 'transaction_checkouts',
    SCHEDULES_POS: 'schedules_pos',
    FORMS_QUESTION_ANSWERS: 'form_question_answers',
    CHECKIN_STEPS: 'checkin_steps',
    SCHEDULES_ADVANCES: 'schedules_advances',
    SCHEDULE_ACTIVITIES_ADVANCES: 'schedules_activities_advances',
    SCHEDULE_ACTIVITIES_ADVANCES_PENDINGS: 'schedules_activities_advances_pendings',
    FORMS_ADDITIONALS: 'forms_additionals',
    CREATE_STORES: 'create_stores',
    FORMS_PERFECT_STORE: 'forms_perfect_stores',
    STORES_PF_RELATION: 'perfect_stores_relation',
    COUNT_STORES: 'count_stores',
    COUNT_SCHEDULES_POS: 'count_schedules_pos',
    COUNT_SCHEDULES_FORMS: 'count_schedules_forms',
    UPLOAD_IMAGES_PENDING: 'upload_images_pending',
    COUNT_FORMS_PERFECT_STORE: 'count_forms_perfect_store',
    COUNT_RELATION_PERFECT_STORE: 'count_relation_perfect_store',
    COUNT_ASSETS_PERFECT_STORE: 'count_assets_perfect_store',
    FORMS_TOTALS: 'forms_totals',
    ASSETS_PF_LINKS: 'assets_pf_links',
    STORES_CREATE_FIELDS: 'stores_create_fields',
    STORES_CREATE_FIELDS_ORGANIZATIONS: 'stores_create_fields_organizations',
    STORES_CREATE_COUNTRIES: 'stores_create_countries',
    STORES_CREATE_PROVINCES: 'stores_create_provinces',
    STORES_CREATE_CITIES: 'stores_create_cities',
    STORES_ORGANIZATIONS: 'stores_organizations',
    STORES_PENDING_SEND: 'stores_pending_send',
    FORMS_PENDING_SYNC: 'forms_pending_sync',
    STORES_INDICATORS: 'stores_indicators',
}

export const POST_TABLE_NAMES = {
    POSTS: 'posts',
    VIEWED_POSTS: 'viewed_posts'
}

export const GAMIFICATION_STORE_NAMES = {
    GAMIFICATION_VERSION: 'gamification_version',
    PARALLAX_ZIP_VERSION: 'gamification_zip',
    GAME_PENDING_SEND: 'game_pending_send',
    SCROLL_CURRENT_LEVEL: 'scroll_current_level',
    LEVEL_ATTEMPTS: 'level_attempts_',
    USED_QUESTIONS_GAME: 'used_questions_game_',
}

// Additional tables/constants used by multiple modules
export const TRACKINGS = {
    TRACKINGS: 'trackings',
}

export const TABLE_ERROR_LOGS = 'error_logs'